<template>
  <el-container>
    <el-main style="padding:0;width:100vh">
      <vm-table
          ref="vmTable"
          :filter.sync="filter"
          module="basic"
          url="returnOrders">
        <div slot="toolbar">
          <el-button type="primary" @click="$refs.editPage.open(0)">
            新建
          </el-button>
        </div>
        <template slot="adSearch">
          <div class="vm-search">
            <vm-search label="申请编号">
              <el-input v-model.trim="filter.returnOrderNo" clearable/>
            </vm-search>
            <vm-search label="申请人">
              <el-input v-model.trim="filter.creatorName" clearable/>
            </vm-search>
            <vm-search label="申请时间">
              <el-date-picker
                  v-model="createTime"
                  :picker-options="pickerOptions"
                  type="daterange"
                  range-separator="至"
                  start-placeholder="开始日期"
                  end-placeholder="结束日期"
                  value-format="yyyy-MM-dd"
                  @change="createTimeChange"/>
            </vm-search>
            <vm-search label="客户名称">
              <el-input v-model.trim="filter.customerName" clearable/>
            </vm-search>
            <vm-search label="出厂编号">
              <el-input v-model.trim="filter.factoryNo" clearable/>
            </vm-search>
            <vm-search label="物流信息">
              <el-input v-model.trim="filter.logistics" clearable/>
            </vm-search>
            <vm-search label="退货单号">
              <el-input v-model.trim="filter.outStockNo" clearable/>
            </vm-search>
          </div>
        </template>
        <el-table-column fixed="left" type="expand">
          <template slot-scope="props">
            <el-table :data="props.row.details">
              <el-table-column prop="factoryNo" width="100" align="center" label="出厂编号"/>
              <el-table-column prop="customerName" width="110" align="center" label="客户名称"/>
              <el-table-column prop="materialNo" width="90" align="center" label="物料编号"/>
              <el-table-column prop="materialName" width="120" align="center" label="物料名称"/>
              <el-table-column prop="quantity" align="center" label="数量"/>
              <el-table-column prop="reason" width="120" align="center" label="退货理由"/>
              <el-table-column prop="remark" width="120" align="center" label="处理意见"/>
              <el-table-column prop="amount" width="120" align="center" label="预估损失金额(元)"/>
              <el-table-column prop="returnDate" align="center" label="退库大概日期"/>
              <el-table-column prop="logistics" width="130" align="center" label="物流信息"/>
              <el-table-column prop="outStockNo" width="100" align="center" label="处理退货单号"/>
            </el-table>
          </template>
        </el-table-column>
        <el-table-column prop="returnOrderNo" width="160" align="center" label="申请编号">
          <template slot-scope="scope">
            <span style="color: #2d8cf0; cursor: pointer" @click="goto(scope.row)">{{scope.row.returnOrderNo}}</span>
            <el-button
                v-clipboard="scope.row.returnOrderNo"
                v-clipboard:success="clipboardSuccessHandler"
                v-clipboard:error="clipboardErrorHandler"
                round
                icon="el-icon-chat-line-square"/>
          </template>
        </el-table-column>
        <el-table-column prop="creatorName" align="center" label="申请人"/>
        <el-table-column prop="departmentName" align="center" label="申请部门"/>
        <el-table-column prop="createTime" align="center" label="申请日期"/>
        <el-table-column prop="nodeDesc" width="140" align="center" label="当前节点"/>
        <el-table-column
            label="操作"
            align="center"
            class-name="vm-table_operate"
            width="120px">
          <template slot-scope="scope">
            <el-button
                v-if="scope.row.status===0"
                type="primary"
                @click="$refs.editPage.open(scope.row.pkid)">
              编辑
            </el-button>
            <el-button
                v-if="scope.row.creatorId === currentId"
                type="danger"
                :disabled="scope.row.status!==0"
                @click="deleteRow(scope.row)">
              删除
            </el-button>
            <el-button
                v-if="scope.row.status===0"
                type="success"
                @click="submit(scope.row.pkid)">
              提交
            </el-button>
          </template>
        </el-table-column>
      </vm-table>
      <return-order-edit ref="editPage" @save-success="getList(1)"/>
    </el-main>
  </el-container>
</template>

<script>
  import VmTable from "@/components/VmTable.vue";
  import VmSearch from "@/components/VmSearch.vue";
  import constant from "@/util/constant";
  import loginUtil from "@/util/loginUtil";
  import ReturnOrderEdit from "@/views/afterSalesManagement/ReturnOrder/ReturnOrderEdit";

  export default {
    name: "",
    components: {ReturnOrderEdit, VmTable, VmSearch},
    data() {
      return {
        constant,
        currentId: loginUtil.getUserId(),
        ids: [],
        pickerOptions: {
          shortcuts: [{
            text: "最近一周",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
              picker.$emit("pick", [start, end]);
            },
          }, {
            text: "最近一个月",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
              picker.$emit("pick", [start, end]);
            },
          }, {
            text: "最近三个月",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
              picker.$emit("pick", [start, end]);
            },
          }],
        },
        createTime: "",
        filter: {
          returnOrderNo: "",
          customerName: "",
          factorNo: "",
          logistics: "",
          outStockNo: "",
          beginCreateTime: "",
          endCreateTime: "",
        },
      };
    },
    mounted() {
      this.$refs.vmTable.getList(1);
    },
    methods: {
      getList(pageNum) {
        this.$refs.vmTable.getList(pageNum);
      },
      createTimeChange(date) {
        if (date !== null) {
          this.filter.beginCreateTime = date[0];
          this.filter.endCreateTime = date[1];
        } else {
          this.filter.beginCreateTime = "";
          this.filter.endCreateTime = "";
        }
      },
      submit(pkid) {
        this.$confirm("确定提交吗?", "提示", {type: "warning"}).then(() => {
          this.$http.get("basic", "returnOrders/submit/" + pkid).then(() => {
            this.$message.success("操作成功");
            this.getList(-1);
          });
        });
      },
      select(selection) {
        this.ids = [];
        for (let item of selection) {
          this.ids.push(item.pkid);
        }
      },
      deleteRow(row) {
        this.ids = [];
        this.ids.push(row.pkid);
        this.deleteRows();
      },
      clipboardSuccessHandler(e) {
        this.$message.success("复制单号成功");
      },
      clipboardErrorHandler(e) {
        this.$message.error("复制单号失败");
      },
      goto(row) {
        this.$router.push({
          path: "/ReturnOrderPreview",
          query: {
            billType: 35,
            billId: row.pkid,
            $tabName: row.returnOrderNo,
          },
        });
      },
      deleteRows() {
        if (this.ids.length === 0) {
          this.$message.error("请先选择删除项");
          return;
        }
        this.$confirm("确定删除吗?", "提示", {type: "warning"}).then(() => {
          this.$http
            .delete("basic", "returnOrders", this.ids)
            .then(() => {
              this.getList(-1);
              this.$message.success("删除成功");
              this.idList = "";
            });
        });
      },
    },
  };
</script>
<style scoped>
</style>
